import React, { ReactNode } from 'react';
import styles from './assets/case-screen.module.scss';
import classNames from 'classnames';
import CasesGrid from './components/CasesGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreateCaseButton from './components/CreateCaseButton';
import RoleLayout from 'src/components/layout/RoleLayout';
import { ICase } from 'src/types/case';
import Loader from '../../../../../../components/Loader';

export interface StateProps {
    data: Paginated<ICase>;
    students: SelectObject[];
    serviceTypes: SelectObject[];
    providers: SelectObject[];
    inProgress: boolean;
    districts: SelectObject[];
    vendors: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getStudents: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class CasesList extends React.Component<Props> {
    //componentDidMount() {}
    componentDidMount() {
        this.props.getStudents({
            page: 1,
        });
        this.props.getServiceTypes({
            page: 1,
        });
        this.props.getVendors({
            page: 1,
        });
        this.props.getProviders({
            page: 1,
        });
        this.props.getDistricts({
            page: 1,
        });
    }
    public render(): ReactNode {
        const { data, getData, students, serviceTypes, districts, providers, vendors, inProgress } = this.props;

        return (
            <RoleLayout>
                <div className={`pageHeading`}>
                    <h2 className={`pageHeadingTitle`}>CASES {data.totalCount ? '(' + data.totalCount + ')' : ''} </h2>
                    <CreateCaseButton />
                </div>
                {inProgress ? <Loader /> : null}

                <div className={classNames(styles.list)}>
                    <CasesGrid
                        students={students}
                        districts={districts}
                        serviceTypes={serviceTypes}
                        providers={providers}
                        vendors={vendors}
                        data={data}
                        getData={getData}
                    />
                </div>
            </RoleLayout>
        );
    }
}

export default CasesList;
